module.exports = __webpack_public_path__ + "img/GH-kyujin-programmer002.3d64bf29.webp";